import { call, select } from 'redux-saga/effects';
import { selectRoomId } from 'features/room/roomSlice';
import { importPollCsvService, importPollTemplateCsvService } from 'features/polls/services';
import { importPollCsvRequested, importPollTemplateCsvRequested } from 'features/polls/actions';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import * as Sentry from '@sentry/react';
import { ApiError } from 'utils/http';

export function* importPollCsvSaga(action: ReturnType<typeof importPollCsvRequested>) {
  try {
    const roomId: string = yield select(selectRoomId);
    yield call(importPollCsvService, roomId, action.payload);
  } catch (error) {
    if (error instanceof ApiError) {
      yield call(
        notification.error,
        error.message || i18n.t('notifications:polls.csv_import_validation_error')
      );
    } else {
      yield call(notification.error, i18n.t('notifications:polls.csv_import_error'));
      Sentry.captureException(error);
    }
  }
}

export function* importPollTemplateCsvSaga(
  action: ReturnType<typeof importPollTemplateCsvRequested>
) {
  try {
    const roomId: string = yield select(selectRoomId);
    yield call(importPollTemplateCsvService, roomId, action.payload);
  } catch (error) {
    if (error instanceof ApiError) {
      yield call(
        notification.error,
        error.message || i18n.t('notifications:polls.csv_import_validation_error')
      );
    } else {
      yield call(notification.error, i18n.t('notifications:polls.csv_import_error'));
      Sentry.captureException(error);
    }
  }
}
